
    import './styles.scoped.css';
    export default {
  "with-motion-vertical": "awsui_with-motion-vertical_b18tp_icwk6_142",
  "with-motion-horizontal": "awsui_with-motion-horizontal_b18tp_icwk6_161",
  "resize-active": "awsui_resize-active_b18tp_icwk6_180",
  "resize-side": "awsui_resize-side_b18tp_icwk6_191",
  "resize-bottom": "awsui_resize-bottom_b18tp_icwk6_194"
};
  